import { Card, Text, Title } from '@mantine/core';

const InteractionCard = ({ title, count }) => {
  if (title === undefined || count === undefined) {
    return '';
  }

  return (
    <Card padding="md" radius="md" withBorder>
      <Title order={5}>{title}</Title>
      <Text c="dimmed">{count} Interactions</Text>
    </Card>
  );
};

export default InteractionCard;
